export default function ImageUploadLoader() {
  return (
    <div className="rel-pos">
      <div className="section-loader image-upload-loader">
        <div className="preloader" id="loader">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
